<template>
  <div><textarea :id="id"></textarea></div>
</template>
<script>
import Urls from '@/assets/js/Urls'
export default {
  name: 'Ckeditor4',
  props: ['value'],
  data: function () {
    return {
      id: parseInt(Math.random() * 10000).toString(),
      ckeditor: null
    }
  },
  mounted: function () {
    const self = this // 渲染编辑器，配置上传图片的路径 // self.ckeditor = window.CKEDITOR.replace(self.id);
    setTimeout(function () {
      self.ckeditor = window.CKEDITOR.replace(self.id, {
        filebrowserImageUploadUrl: `${Urls.DOMAIN_STATIC}/Upload/CkeditorImage`,
        height: 500
      })

      self.ckeditor.setData(self.value)
      self.ckeditor.on('change', function () {
        self.$emit('input', self.ckeditor.getData())
      })
    }, 100)
  },
  watch: {
    // 监听prop的变化，更新ckeditor中的值
    value: function () {
      if (this.ckeditor && this.value !== this.ckeditor.getData()) {
        this.ckeditor.setData(this.value)
      }
    }
  },
  // 销毁组件前，销毁编辑器
  beforeDestroy: function () {
    if (this.ckeditor) {
      this.ckeditor.destroy()
    }
  }
}
</script>
